import { createError } from 'requests/errors'
import axios from 'axios'
import { AUTH_API_URL } from 'lib/env'

export const postLogin = async userData => {
  try {
    const res = await axios.post(AUTH_API_URL + '/authenticate', userData)
    return res.data
  } catch (e) {
    return createError(e)
  }
}

export const getUsers = async (data = {}) => {
  try {
    const res = await axios.post(AUTH_API_URL + '/users/getUsers', {
      isActive: true,
      limit: 1000,
      offset: 0,
      ...data
    })
    return res.data
  } catch (e) {
    return createError(e)
  }
}

export const getUsersAdmin = async (data = {}) => {
  try {
    const response = await axios.post(AUTH_API_URL + '/users/getUsers', {
      isActive: true,
      limit: 50,
      offset: 0,
      projectCode: 'SUPPORT_ADMIN',
      roleCode: 'ADMIN',
      ...data
    })

    return response.data
  } catch (error) {
    return createError(error)
  }
}

export const getBranches = async () => {
  try {
    const res = await axios.get(AUTH_API_URL + '/branches')
    return res.data
  } catch (e) {
    return createError(e)
  }
}

export const getUsersByRole = async (role = '', project = '') => {
  try {
    const res = await axios.get(
      AUTH_API_URL +
        `/users/getUsersByRole?roleCode=${role}&projectCode=${project}`
    )
    return res.data
  } catch (e) {
    return createError(e)
  }
}

export const getUserByToken = async (phone = '', email = '') => {
  try {
    const res = await axios.get(
      AUTH_API_URL + `/users/getUserByToken?phone=${phone}&email=${email}`
    )
    return res.data
  } catch (e) {
    return createError(e)
  }
}

export const getSubdivisions = async () => {
  try {
    const result = await axios.post(
      AUTH_API_URL + '/dictionary/subdivisions',
      { active: true }
    )
    return { status: result?.status, data: result?.data }
  } catch (e) {
    return createError(e)
  }
}
